export interface RegimenFaqSlide {
  type: string;
  url: string;
  thumbnailUrl?: string;
  aspectRatio?: string;
}

export interface RegimenFaqPost {
  objectId: string;
  question: string;
  slides: RegimenFaqSlide[];
  ctaText?: string;
  ctaUrl?: string;
}

export interface RegimenFaqMediaLanguageJson {
  [language: string]: RegimenFaqSlide[];
}

export interface RegimenFaqCaptionLanguageJson {
  [language: string]: string;
}

export interface RegimenFaqFeed {
  objectId: string;
  captionLanguageJson?: RegimenFaqCaptionLanguageJson;
  mediaLanguageJson?: RegimenFaqMediaLanguageJson;
  ctaText?: string;
  ctaUrl?: string;
}

export const REGIMEN_FAQ_CTA = {
  ADD_ADDRESS: 'ADD_ADDRESS',
} as const;

export const ADDRESS_ROUTE = {
  NEW: '/user/address/new',
  CHECKOUT: '/user/checkout',
} as const;

export const STORY_START_INDEX = 1;

export const REGIMEN_FAQ_DOCTOR = {
  name: 'Dr Charu Sharma',
  title: 'Head of Dermatology',
  imageUrl: 'https://cdn.cureskin.com/app/img/dr_charu_thumbnail_2026.png',
} as const;

export const REGIMEN_FAQ_EVENT = {
  OPEN: 'regimen_FAQ',
  CTA: 'regimen_FAQ_CTA',
  STORY_TAP: 'regimen_FAQ_story_tap',
} as const;
